"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TDocDeployer__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "ImplementationAlreadyAdded",
  type: "error"
}, {
  inputs: [{
    internalType: "bytes",
    name: "payload",
    type: "bytes"
  }],
  name: "ImplementationInitializationFailure",
  type: "error"
}, {
  inputs: [],
  name: "InvalidImplementation",
  type: "error"
}, {
  inputs: [],
  name: "UnsupportedImplementationContractAddress",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }],
  name: "AddImplementation",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "previousAdmin",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "newAdmin",
    type: "address"
  }],
  name: "AdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beacon",
    type: "address"
  }],
  name: "BeaconUpgraded",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "deployed",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "deployer",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "params",
    type: "bytes"
  }],
  name: "Deployment",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "OwnershipTransferred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "Upgraded",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }],
  name: "addImplementation",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }, {
    internalType: "bytes",
    name: "params",
    type: "bytes"
  }],
  name: "deploy",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "implementations",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "owner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "proxiableUUID",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "implementation",
    type: "address"
  }],
  name: "removeImplementation",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "renounceOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newOwner",
    type: "address"
  }],
  name: "transferOwnership",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }],
  name: "upgradeTo",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newImplementation",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "upgradeToAndCall",
  outputs: [],
  stateMutability: "payable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class TDocDeployer__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TDocDeployer__factory = TDocDeployer__factory;

_defineProperty(TDocDeployer__factory, "bytecode", _bytecode);

_defineProperty(TDocDeployer__factory, "abi", _abi);